<template>
  <Dialog
    class="relative z-10"
    :open="isDrawerOpen"
    @close="isDrawerOpen = false"
  >
    <div
      class="bg-opacity-75 fixed inset-0 bg-gray-500 transition-opacity"
    ></div>

    <div class="fixed inset-0 overflow-hidden">
      <div class="absolute inset-0 overflow-hidden">
        <div
          class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16"
        >
          <DialogPanel class="pointer-events-auto w-screen max-w-2xl">
            <div
              class="flex h-full flex-col gap-6 overflow-y-scroll bg-white px-4 py-6 shadow-xl sm:px-6"
            >
              <div class="flex items-start justify-end gap-3">
                <DialogTitle class="flex-1">
                  <slot name="title"></slot>
                </DialogTitle>
                <button @click="isDrawerOpen = false">
                  <Icon :icon="XMarkIcon" size="lg" class="text-gray-300" />
                </button>
              </div>
              <div class="relative flex-1">
                <slot></slot>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/vue";
import { XMarkIcon } from "@heroicons/vue/24/outline";

const isDrawerOpen = defineModel<boolean>({ default: false });
</script>
